module.exports = __webpack_public_path__ + "img/制御工学6_5.57919dfe.png";